const Emoji_M = {
    ':mad_2': { id: 335, width: 22, height: 28 },
    ':mad': { id: 336, width: 20, height: 20 },
    ':mail1': { id: 337, width: 18, height: 24 },
    ':mail2': { id: 338, width: 44, height: 33 },
    ':man': { id: 339, width: 19, height: 20 },
    ':marinheiro': { id: 340, width: 25, height: 25 },
    ':matrix2': { id: 341, width: 18, height: 18 },
    ':megalol': { id: 342, width: 20, height: 20 },
    ':mellow': { id: 343, width: 20, height: 20 },
    ':mobile': { id: 344, width: 31, height: 24 },
    ':mog': { id: 345, width: 33, height: 33 },
    ':moptop': { id: 346, width: 20, height: 19 },
    ':mug': { id: 52, width: 18, height: 18 },
    ':mushy': { id: 348, width: 20, height: 20 },
    ':music_blues': { id: 349, width: 24, height: 25 },
    ':music_dj': { id: 350, width: 28, height: 28 },
    ':music_walkman': { id: 352, width: 26, height: 24 },
    ':music_whistling_1': { id: 353, width: 19, height: 18 },
    ':music_whistling': { id: 354, width: 35, height: 20 },
    ':music': { id: 351, width: 22, height: 23 },
}

export default Emoji_M
